module.exports = __webpack_public_path__ + "img/Customer_Code.c3b4323e.jpg";